import { render, staticRenderFns } from "./statistical.vue?vue&type=template&id=f544ac54&scoped=true&"
import script from "./statistical.vue?vue&type=script&lang=ts&"
export * from "./statistical.vue?vue&type=script&lang=ts&"
import style0 from "./statistical.vue?vue&type=style&index=0&id=f544ac54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f544ac54",
  null
  
)

export default component.exports